import React from 'react';
import { func, object, string } from 'prop-types';
import classNames from 'classnames';

import { INDEX_LETTERS } from '../../util/seoDiscoveryIndexLetters';
import css from './SeoDiscovery.module.css';

const SeoIndexAlphabetNav = props => {
  const { activeLetter, getLetterHref, letterCounts } = props;

  return (
    <nav className={css.alphabetNav} aria-label="Alphabet navigation">
      {INDEX_LETTERS.map(letter => {
        const count = letterCounts?.[letter] || 0;
        if (count <= 0) {
          return (
            <span key={letter} className={css.alphabetDisabled}>
              {letter}
            </span>
          );
        }
        const href = getLetterHref(letter);
        const isActive = activeLetter === letter;
        return (
          <a
            key={letter}
            className={classNames({ [css.alphabetActive]: isActive })}
            href={href}
            aria-current={isActive ? 'page' : undefined}
          >
            {letter}
          </a>
        );
      })}
    </nav>
  );
};

SeoIndexAlphabetNav.propTypes = {
  activeLetter: string,
  getLetterHref: func.isRequired,
  letterCounts: object,
};

export default SeoIndexAlphabetNav;
